import styles from './index.module.scss';
import { useEffect, useState } from 'react'
import { hotResourceList } from '@/apis/discover.js';
import ResourceCard from '@/components/ResourceCard';

const HotResource = ({ secondType }) => {
	const [hotList, setHotList] = useState([]);
	const getList = () => {
		hotResourceList({
			secondType: secondType,
			limit: 6
		}).then(res => {
			console.log(res.data)
			setHotList(res.data)
		})
	}
	useEffect(() => {
		if (secondType) {
			getList()
		}
	}, [secondType])


	const updateData = (id, flag) => {
		setHotList(hotList.map(item => {
			if (item.resourceUuid === id) {
				return {
					...item,
					isFavorite: flag,
					collectTimes: flag ? item.collectTimes + 1 : item.collectTimes - 1
				}
			} else {
				return item
			}
		}))
	}

	return <div className={styles.selectBox}>
		{
			hotList.map(item => <ResourceCard data={item} rows={2} changeData={updateData} isShowView />)
		}
	</div>
}
export default HotResource;